export const INVALID_ATTEMPTS_MAX_TIME_INTERVAL = 60;
const MAX_INVALID_ATTEMPTS = 3;

const manageLocalStorage = (key: string, action: 'get' | 'set' | 'remove', value: string | null = null) => {
  try {
    switch (action) {
      case 'get':
        return localStorage.getItem(key);
      case 'set':
        if (!value) break;
        localStorage.setItem(key, value);
        break;
      case 'remove':
        localStorage.removeItem(key);
        break;
      default:
        break;
    }
  } catch (error) {
    return null;
  }
};

export const isAttemptAllowed = (key: string) => {
  const localStorageData = manageLocalStorage(key, 'get');
  if (!localStorageData || typeof localStorageData !== 'string') return true;
  const invalidAttemptsData = JSON.parse(localStorageData);
  const { initialTime, tries } = invalidAttemptsData;
  const diffInMins = Math.abs(new Date().getTime() - initialTime) / (1000 * 60);
  if (diffInMins >= INVALID_ATTEMPTS_MAX_TIME_INTERVAL) {
    manageLocalStorage(key, 'remove');
    return true;
  }
  if (tries < MAX_INVALID_ATTEMPTS) {
    return true;
  }
  return false;
};

export const handleInvalidPasswordLimit = (key: string, fields?: { oldPassword?: string, newPassword?: string, newPasswordVerification?: string, password?: string } | undefined) => {
  if (!fields || fields.oldPassword || fields.password) {
    let invalidAttemptsData = {
      initialTime: new Date().getTime(),
      tries: 0
    };
    const localStorageData = manageLocalStorage(key, 'get');
    if (localStorageData && typeof localStorageData === 'string') {
      invalidAttemptsData = JSON.parse(localStorageData);
    }
    invalidAttemptsData.tries += 1;
    manageLocalStorage(key, 'set', JSON.stringify(invalidAttemptsData));
    // when initially saving data, set timer to automatically reset after time limit is reached
    if (!localStorageData) {
      setTimeout(() => {
        manageLocalStorage(key, 'remove');
      }, 1000 * 60 * INVALID_ATTEMPTS_MAX_TIME_INTERVAL);
    }
  }
};
